import { createFileRoute, redirect } from '@tanstack/react-router';

import { BenefitsSection } from './-components/benefits-section';
import { FaqSection } from './-components/faq-section';
import { FinalCtaSection } from './-components/final-cta-section';
import { Hero } from './-components/hero';
import { HowItWorksSection } from './-components/how-it-works-section';
import { PainSection } from './-components/pain-section';
import { PartnersSection } from './-components/partners-section';
import { PricingSection } from './-components/pricing-section';
import { SolutionSection } from './-components/solution-section';
import { TestimonialsSection } from './-components/testimonials-section';

export const Route = createFileRoute('/(landing)/')({
  beforeLoad: async () => {
    const token = localStorage.getItem('access_token');
    if (token) {
      throw redirect({ to: '/home' });
    }
  },
  component: LandingPage,
});

function LandingPage() {
  return (
    <>
      <Hero />
      <PartnersSection />
      <PainSection />
      <SolutionSection />
      <BenefitsSection />
      <HowItWorksSection />
      <PricingSection />
      <TestimonialsSection />
      <FaqSection />
      <FinalCtaSection />
    </>
  );
}
